import React from 'react';
import ResponsivePaddingWrapper from '../../../../component/responsive/responsivePaddingWrapper';
import { lineColor } from '../../../../util/colors';
import { useMobile } from '../../../../hook/usePlatform';
import IntroSection from '../../../../component/introSection';
import RecommendMemberList from './component/RecommendMemberList';
import { LogOutTextButton } from '../../../../component/logout';

const MemberListPage:React.FC = () => {
  const isMobile = useMobile();
  const border = isMobile ? '' : `solid 1px ${lineColor}`;
  return (
    <div>
      <ResponsivePaddingWrapper style={{ borderBottom: border }}>
        <IntroSection title="[추천리스트]" content="시럽인연에서 추천된 회원 현황을 확인할 수 있어요." />
      </ResponsivePaddingWrapper>
      <ResponsivePaddingWrapper style={{ paddingBlock: isMobile ? 52 : 80    }}>
        <RecommendMemberList />
        <div style={{ marginTop: 100  }}>
          <LogOutTextButton />
        </div>
      </ResponsivePaddingWrapper>
    </div>
  );
};

export default MemberListPage;
